<script setup lang="ts">
import { useMessage } from "@/hooks/web/useMessage";
import { setGlobalMessage } from "@/utils/message";

const message = useMessage();
setGlobalMessage(message);
</script>
<template><span v-show="false" /></template>
